export function initMegaMenu(wrapper: HTMLDivElement) {

	let expander = wrapper.querySelector('[data-megamenu-expander]');
	if (expander) {
		expander.addEventListener('click', (e) => {
			toggleMegaMenu(wrapper);
			e.preventDefault();
			e.stopPropagation();
		})
	}


	let overlay = wrapper.querySelector('[data-overlay]');
	if (overlay) {
		overlay.addEventListener('click', (e) => {
			hideMegaMenu(wrapper);
		})
	}

	document.body.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			hideMegaMenu(wrapper);
			e.preventDefault();
			e.stopPropagation();
		}
	})


}

function toggleMegaMenu(wrapper: HTMLDivElement) {
	if (wrapper.classList.contains('megamenu--open')) {
		hideMegaMenu(wrapper);
	} else {
		showMegaMenu(wrapper);
	}
}

function showMegaMenu(wrapper: HTMLDivElement) {
	wrapper.classList.add('megamenu--open')
	document.body.classList.add('body--megamenu-open');
}

function hideMegaMenu(wrapper: HTMLDivElement) {
	wrapper.classList.remove('megamenu--open')
	document.body.classList.remove('body--megamenu-open');
}

